"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable */
var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 37.9997C29.4934 37.9997 38 29.4932 38 18.9997C38 8.50634 29.4934 -0.000244141 19 -0.000244141C8.50659 -0.000244141 0 8.50634 0 18.9997C0 29.4932 8.50659 37.9997 19 37.9997Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0416 15.0415C34.0416 25.5349 25.535 34.0414 15.0416 34.0414C10.8045 34.0414 6.89142 32.6545 3.73145 30.3099C7.19347 34.9759 12.7436 37.9998 18.9999 37.9998C29.4933 37.9998 37.9999 29.4932 37.9999 18.9998C37.9999 12.7434 34.976 7.19334 30.3101 3.73132C32.6547 6.8913 34.0416 10.8044 34.0416 15.0415Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4896 19.7914C13.6595 19.7914 16.2292 17.2217 16.2292 14.0518C16.2292 10.882 13.6595 8.31226 10.4896 8.31226C7.3197 8.31226 4.75 10.882 4.75 14.0518C4.75 17.2217 7.3197 19.7914 10.4896 19.7914Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5103 19.7914C30.6802 19.7914 33.2499 17.2217 33.2499 14.0518C33.2499 10.882 30.6802 8.31226 27.5103 8.31226C24.3405 8.31226 21.7708 10.882 21.7708 14.0518C21.7708 17.2217 24.3405 19.7914 27.5103 19.7914Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4895 15.8331C11.4733 15.8331 12.2708 15.0356 12.2708 14.0519C12.2708 13.0681 11.4733 12.2706 10.4895 12.2706C9.50574 12.2706 8.70825 13.0681 8.70825 14.0519C8.70825 15.0356 9.50574 15.8331 10.4895 15.8331Z",
    fill: "#262626"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5105 15.8331C28.4943 15.8331 29.2917 15.0356 29.2917 14.0519C29.2917 13.0681 28.4943 12.2706 27.5105 12.2706C26.5267 12.2706 25.7292 13.0681 25.7292 14.0519C25.7292 15.0356 26.5267 15.8331 27.5105 15.8331Z",
    fill: "#262626"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.53125 18.2081C7.56495 19.1806 8.95163 19.7915 10.4896 19.7915C12.0275 19.7915 13.4268 19.193 14.4479 18.2081H6.53125Z",
    fill: "#50DCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.552 18.2081C24.5857 19.1806 25.9724 19.7915 27.5103 19.7915C29.0483 19.7915 30.4476 19.193 31.4687 18.2081H23.552Z",
    fill: "#50DCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2383 27.0131C14.309 25.3944 16.565 24.2855 19.1779 24.2855C21.7908 24.2855 24.0468 25.3944 25.1174 27.0131C25.1174 27.0131 26.0734 28.4406 27.0293 27.0131C25.9969 24.5531 22.8742 22.756 19.1779 22.756C15.4816 22.756 12.3588 24.5531 11.3264 27.0131L11.3264 27.0131C12.2824 28.4406 13.2383 27.0131 13.2383 27.0131L13.2383 27.0131Z",
    fill: "black"
  }));
};
exports.default = _default;